import { isDefaultZipCode } from 'site-modules/shared/utils/inventory/is-default-zip-code';
import { US_STATES_CODES_LIST } from 'client/data/constants/united-states-codes-list';

export const isZipLongDistance = ({ isUserSetZip, zipCode, stateCode }) => {
  return (!isUserSetZip && isDefaultZipCode(zipCode)) || (stateCode && !US_STATES_CODES_LIST.includes(stateCode));
};

export const hideEmbeddedLeadForm = ({ isVdp, isPartnerListing, isUserSetZip, zipCode, stateCode }) => {
  return isVdp && isPartnerListing && isZipLongDistance({ isUserSetZip, zipCode, stateCode });
};
